import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaXmark, FaArrowRight } from "react-icons/fa6";
import "./SocialWallofFame.css";

const SOCIAL_POSTS_DATA = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
    title:
      "A moment of pride for us – Mr. Suniel Shetty shared his powerful experience at Vibrant Buildcon 2025",
    content:
      "India isn't just building for itself anymore. We're building for the world! I felt so proud being at Vibrant Buildcon 2025 / Bharat Buildcon, applauding India's innovation, scale, and spirit of entrepreneurship. Seeing over 1,000+ exhibitors showcasing cutting-edge ceramic, stone, and structural engineering materials under one roof is proof of India's global dominance.",
    tags: [
      "#SunielShetty",
      "#VibrantBuildcon2025",
      "#MakeInIndia",
      "#BuildForWorld",
    ],
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1000&q=80",
    title:
      "Commending Bharat Buildcon for Accelerating India's $5 Trillion Economic Footprint",
    content:
      "Hon'ble Union Ministers lauded Bharat Buildcon & Vibrant Buildcon for establishing a premier international platform connecting Indian manufacturers directly with buyers across 35+ countries. The export corridor created here will drive massive momentum in building material trade.",
    tags: [
      "#PiyushGoyal",
      "#CommerceMinistry",
      "#GlobalTrade",
      "#AatmanirbharBharat",
    ],
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1590486803833-1c5dc8ddd4c8?auto=format&fit=crop&w=1000&q=80",
    title:
      "Morbi Ceramic Cluster Generates Record International Orders at Expo",
    content:
      "Morbi produces over 90% of India's total ceramic exports. At Bharat Buildcon 2025, our 800+ manufacturing units booked record export inquiries from Europe, North America, and the Middle East! Gratitude to the organizing committee.",
    tags: ["#MorbiCeramics", "#TileExpo", "#ExportHub", "#IndianTiles"],
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1000&q=80",
    title:
      "Unlocking £500M+ Infrastructure Material Trade Corridors with India",
    content:
      "Delegates from the UK High Commission and commercial trade council participated in key bilateral roundtables at Vibrant Buildcon 2025. Lower tariffs and streamlined export channels are opening unprecedented possibilities for Indian suppliers.",

    tags: [
      "#UKIndiaTrade",
      "#FTAAgreement",
      "#InfrastructureExports",
      "#GlobalTrade",
    ],
  },
  {
    id: 5,
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1000&q=80",
    title:
      "CNBC Live Report: How Vibrant Buildcon 2025 Redefined Global ConTech Expos",
    content:
      "Watch our exclusive 4K documentary walkthrough showcasing robotic site survey drones, 4D BIM software, and green concrete formulations live from the Vibrant Buildcon exhibition floor.",

    tags: ["#CNBCTV18", "#ConTech", "#MediaCoverage", "#LiveInterview"],
  },
  {
    id: 6,
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1000&q=80",
    title:
      "Dubai & Riyadh Architectural Delegates Award High Praise for Indian Porcelain Tech",
    content:
      "A 60-member delegation of GCC architects and mega-project developers visited Bharat Buildcon. The precision engineering of large-format slab tiles and sustainable glass facades exceeded global luxury standards.",

    tags: ["#DubaiArchitects", "#GCCImport", "#LuxuryCeramics", "#GlobalInfra"],
  },
  {
    id: 7,
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1000&q=80",
    title:
      "Positioning Gujarat as the World's Building Material Manufacturing Hub",
    content:
      "Addressing over 10,000+ national and foreign delegates, Gujarat's leadership reaffirmed complete policy support for eco-friendly ceramic clusters, industrial parks, and direct port connectivity.",

    tags: [
      "#VibrantGujarat",
      "#Buildcon2025",
      "#StateLeadership",
      "#GujaratExports",
    ],
  },
  {
    id: 8,
    image:
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1000&q=80",
    title: "Celebrating Eco-Resilient Concrete & Zero-Waste Innovations",
    content:
      "Honoring the 2025 Green Innovation Award winners at Bharat Buildcon! From carbon-capturing cement to solar facade glass, Indian pioneers are leading the world toward zero-carbon construction.",

    tags: ["#GreenConcrete", "#BuildconAwards", "#EcoBuild", "#Sustainability"],
  },
];

const SocialWallofFame = () => {
  const [selectedPost, setSelectedPost] = useState(null);

  return (
    <div className="social-wall-page">
      <Helmet>
        <title>Social Wall of Fame | Bharat Buildcon</title>
      </Helmet>
      {/* Background Glow Orbs */}
      <div className="wall-ambient-glow glow-1"></div>
      <div className="wall-ambient-glow glow-2"></div>

      {/* HEADER SECTION */}
      <section className="wall-header-section">
        <div className="clean-breadcrumb-wrapper">
          <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="bc-home-link">
              HOME
            </Link>
            <span className="bc-slash">/</span>
            <span className="bc-active-page">SOCIAL WALL OF FAME</span>
          </nav>
        </div>

        <h1 className="wall-main-title">
          Social Wall Of <span className="gradient-gold">Fame</span>
        </h1>

        <p className="wall-subtitle-text">
          Celebrating global icons, brand ambassadors, Union Ministers,
          international trade delegations, and news highlights applauding Bharat
          Buildcon & Vibrant Buildcon.
        </p>
      </section>

      {/* MASONRY/GRID OF SOCIAL WALL CARDS */}
      <section className="wall-grid-section">
        <div className="wall-cards-grid">
          {SOCIAL_POSTS_DATA.map((post) => {
            return (
              <div key={post.id} className="wall-card-slot">
                <div
                  className="wall-post-card"
                  onClick={() => setSelectedPost(post)}
                >
                  {/* Card Media Preview */}
                  <div className="card-media-wrapper">
                    <img
                      src={post.image}
                      alt={post.author}
                      className="card-img"
                    />
                  </div>

                  {/* Card Body */}
                  <div className="card-body-content">
                    <h3 className="card-title">{post.title}</h3>
                    <p className="card-excerpt">{post.content}</p>

                    <div className="card-tags-cloud">
                      {post.tags.slice(0, 3).map((tag, i) => (
                        <span key={i} className="mini-tag">
                          {tag}
                        </span>
                      ))}
                    </div>

                    {/* Card Footer */}
                    <div className="card-footer-actions">
                      <button className="card-read-more-btn">
                        View <FaArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* FULL POST LIGHTBOX MODAL */}
      {selectedPost && (
        <div
          className="wall-modal-backdrop"
          onClick={() => setSelectedPost(null)}
        >
          <div className="wall-modal-card" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close-btn"
              onClick={() => setSelectedPost(null)}
              title="Close Modal"
            >
              <FaXmark />
            </button>

            <div className="modal-top-media">
              <img
                src={selectedPost.image}
                alt={selectedPost.author}
                className="modal-cover-img"
              />
            </div>

            <div className="modal-inner-body">
              <h2 className="modal-post-title">{selectedPost.title}</h2>
              <p className="modal-post-content">{selectedPost.content}</p>

              <div className="modal-tags-row">
                {selectedPost.tags.map((tag, idx) => (
                  <span key={idx} className="modal-tag-chip">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialWallofFame;
